import React, { useState, useEffect, useContext } from 'react';
import { createSales, updateSales, getProducts, createPurchase, getSuppliers, getBrand, getManufacturers, createPurchaseorder } from '../../../Utility/Api'; // Remove getProducts and getUsers if you're using dummy data
import { toast } from 'react-toastify';
import { WarehouseContext } from '../../../Utility/UserContext';

const SalesForm = ({ selectedSale, onClose, fetchSales, fetchPurchase }) => {
  const [formData, setFormData] = useState({
    employee_id: '',
    Date_time: '',
    status: '1',
  });

  const [products, setProducts] = useState([]);
  const [users, setUsers] = useState([]); // List of users to map user_id to username
  const { showLoader, hideLoader, UserItem } = useContext(WarehouseContext);
  const UserId = UserItem?.user_id;

  useEffect(() => {
    fetchProducts();
    if (selectedSale) {
      setFormData({
        poid: selectedSale.po || '',
        customer_name: selectedSale.customer_name,
        warranty_period: selectedSale.warranty_period,
        status: selectedSale.status.toString(),
        user_id: selectedSale.user_id || '' // Populate user_id for editing
      });
    }
  }, [selectedSale]);

  // Dummy data for products
  const fetchProducts = async () => {
    try {
      const response = await getProducts();
      if (response.data && response.data.data) {
        setProducts(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
      toast.error("Error fetching products");
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {

    showLoader()
    e.preventDefault();

    const payload = {
      product_id: formData.product_id,
      employee_id: UserId,
      Date_time: formData.Date_time,
      status: formData.status,
    };

    try {
      if (selectedSale) {
        await updateSales(selectedSale.sale_id, payload);
        hideLoader()
        toast.success('Purchase Order updated successfully');
      } else {
        await createPurchase(payload);
        hideLoader()
        toast.success('Purchase Order added successfully');
        fetchPurchase();
      }
      onClose();
      hideLoader()
    } catch (error) {
      console.error('Error saving Purchase Order data:', error);
      hideLoader()
      toast.error('Error saving Order');
    }
  };

  return (
    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{ fontFamily: "poppins" }}>{selectedSale ? 'Edit Purchase' : 'Add Purchase'}</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              {/* <div className="form-group mb-3">
                <label>Pruchase Product</label>
                <select
                  name="product_id"
                  value={formData.product_id}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  <option value="">Select Pruchase Product</option>
                  {products.map((prod) => (
                    <option key={prod.product_id} value={prod.product_id}>
                      {prod.product_name}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className="form-group mb-3">
                <label>Date & Time</label>
                <input
                  type="datetime-local"
                  name="Date_time"
                  value={formData.Date_time}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>
              {/* <div className="form-group mb-3">
                <label>Employee</label>
                <select
                  name="user_id"
                  value={formData.user_id}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  <option value="">Select Employee</option>
                  {users.map((user) => (
                    <option key={user.user_id} value={user.user_id}>
                      {user.name}
                    </option>
                  ))}
                </select>
              </div> */}

              {selectedSale && (
                <div className="form-group mb-3">
                  <label>Status</label>
                  <select
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                    className="form-control"
                    required
                  >
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
              )}
              <button type="submit" className="btn btn-primary float-end">
                {selectedSale ? 'Update Purchase' : 'Add Purchase'}
              </button>
              <button
                type="button"
                className="btn btn-secondary ml-2 float-end me-1"
                onClick={onClose}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
// const SalesForm = ({ selectedSale, onClose, fetchSales,fetchPurchase  }) => {
//   const [formData, setFormData] = useState({
//     employee_id: '',
//     Date_time: '',
//     status: '',
//   });

//   const UserId = JSON.parse(localStorage.getItem("AuthUser"))?.user?.user_id; 

//   const [products, setProducts] = useState([]);
//   const [users, setUsers] = useState([]); // List of users to map user_id to username

//   useEffect(() => {
//     fetchProducts();
//     if (selectedSale) {
//       setFormData({
//         poid: selectedSale.po || '',
//         customer_name: selectedSale.customer_name,
//         warranty_period: selectedSale.warranty_period,
//         status: selectedSale.status.toString(),
//         user_id: selectedSale.user_id || '' // Populate user_id for editing
//       });
//     }
//   }, [selectedSale]);

//   // Dummy data for products
//   const fetchProducts = async () => {
//     try {
//       const response = await getProducts();
//       if (response.data && response.data.data) {
//         setProducts(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching product data:", error);
//       toast.error("Error fetching products");
//     }
//   };


//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prevState => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const payload = {
//       product_id: formData.product_id,
//       employee_id: UserId,
//       Date_time:formData.Date_time,
//       status: formData.status,
//     };

//     try {
//       if (selectedSale) {
//         await updateSales(selectedSale.sale_id, payload);
//         toast.success('Purchase Order updated successfully');
//       } else {
//         await createPurchase(payload);
//         toast.success('Purchase Order added successfully');
//         fetchPurchase();
//       }
//       onClose();
//     } catch (error) {
//       console.error('Error saving Purchase Order data:', error);
//       toast.error('Error saving Order');
//     }
//   };

//   return (
//     <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
//       <div className="modal-dialog">
//         <div className="modal-content">
//           <div className="modal-header">
//             <h5 className="modal-title">{selectedSale ? 'Edit Purchase' : 'Add Purchase'}</h5>
//             <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
//           </div>
//           <div className="modal-body">
//             <form onSubmit={handleSubmit}>
//               {/* <div className="form-group mb-3">
//                 <label>Pruchase Product</label>
//                 <select
//                   name="product_id"
//                   value={formData.product_id}
//                   onChange={handleChange}
//                   className="form-control"
//                   required
//                 >
//                   <option value="">Select Pruchase Product</option>
//                   {products.map((prod) => (
//                     <option key={prod.product_id} value={prod.product_id}>
//                       {prod.product_name}
//                     </option>
//                   ))}
//                 </select>
//               </div> */}
//               <div className="form-group mb-3">
//   <label>Date & Time</label>
//   <input
//     type="datetime-local" 
//     name="Date_time"
//     value={formData.Date_time} 
//     onChange={handleChange}
//     className="form-control"
//     required
//   />
// </div>
//               {/* <div className="form-group mb-3">
//                 <label>Employee</label>
//                 <select
//                   name="user_id"
//                   value={formData.user_id}
//                   onChange={handleChange}
//                   className="form-control"
//                   required
//                 >
//                   <option value="">Select Employee</option>
//                   {users.map((user) => (
//                     <option key={user.user_id} value={user.user_id}>
//                       {user.name}
//                     </option>
//                   ))}
//                 </select>
//               </div> */}

//               <div className="form-group mb-3">
//                 <label>Status</label>
//                 <select
//                   name="status"
//                   value={formData.status}
//                   onChange={handleChange}
//                   className="form-control"
//                   required
//                 >
//                   <option value="" disabled>Select Status</option>
//                   <option value="1">Active</option>
//                   <option value="0">Inactive</option>
//                 </select>
//               </div>
//               <button type="submit" className="btn btn-primary float-end">
//                 {selectedSale ? 'Update Purchase' : 'Add Purchase'}
//               </button>
//               <button
//                 type="button"
//                 className="btn btn-secondary ml-2 float-end me-1"
//                 onClick={onClose}
//               >
//                 Cancel
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// Sales Table Component
const SalesTable = ({ salesData, salesDetails, handleEdit, handleCancel, handleConfirm }) => {
  return (
    <div>
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th className="text-start">Employee Name</th>
              <th className="text-end">Date</th>
              <th className="text-center">PO ID</th>
            </tr>
          </thead>
          <tbody>
            {salesData.map((sale) => (
              <tr key={sale.po_id}>
                <td>{sale.employeeName}</td>
                <td>{new Date(sale.date).toLocaleDateString()}</td>
                <td>{sale.po_id}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Detailed Sales Information Table */}
      <div className="table-responsive mt-4">
        <table className="table table-sm table-striped" style={{ fontFamily: "poppins" }}>
          <thead>
            <tr>
              <th>PO ID</th>
              <th>Brand</th>
              <th>Manufacturer</th>
              <th>Supplier</th>
              <th>Quantity</th>
              <th>Price (INR)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {salesDetails.map((detail) => (
              <tr key={detail.poid}>
                <td>{detail.poid}</td>
                <td>{detail.brand}</td>
                <td>{detail.manufacturer}</td>
                <td>{detail.supplier}</td>
                <td>{detail.quantity}</td>
                <td>{detail.price}</td>
                <td>
                  <button className="btn btn-primary btn-sm" onClick={() => handleEdit(detail.poid)}>
                    Edit
                  </button>
                  <button className="btn btn-danger btn-sm ml-2" onClick={() => handleCancel(detail.poid)}>
                    Cancel
                  </button>
                  <button className="btn btn-success btn-sm ml-2" onClick={() => handleConfirm(detail.poid)}>
                    Confirm
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};


const PurchaseorderForm = ({ selectedPurchase, onClose, reloadlist, PO_Data }) => {
  const [formData, setFormData] = useState({
    items: '',
    supplier_id: '',
    manufacturer_id: '',
    brands_id: '',
    qty: '',
    price_per_units: '',
    status: '1',
    purchase_id: "",
  });

  const [supplier, setSupplier] = useState([]);
  const [Brand, setBrand] = useState([]);
  const [Manufacturers, setManufacturers] = useState([]);
  const [products, setProducts] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchProducts();
    fetchBrand();
    fetchSuppliers();
    fetchManufacturers();

    if (selectedPurchase) {
      setFormData({
        poid: selectedPurchase.po || '',
        customer_name: selectedPurchase.customer_name,
        status: selectedPurchase.status.toString(),
        user_id: selectedPurchase.user_id || '' // Populate user_id for editing
      });
    }
  }, [selectedPurchase]);



  const fetchSuppliers = async () => {
    try {
      const response = await getSuppliers();
      if (response.data && response.data.data) {
        setSupplier(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching suppliers data:", error);
    }
  };

  const fetchBrand = async () => {
    try {
      const response = await getBrand();
      if (response.data && response.data.data) {
        setBrand(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching product data:', error);
    }
  };

  const fetchManufacturers = async () => {
    try {
      const response = await getManufacturers();
      if (response.data && response.data.data) {
        setManufacturers(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching Customers data:', error);
    }
  };

  // Dummy data for products
  const fetchProducts = async () => {
    try {
      const response = await getProducts();
      if (response.data && response.data.data) {
        setProducts(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
      toast.error("Error fetching products");
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "qty" || name === "price_per_units") {
      if (!/^\d*\.?\d*$/.test(value)) {
        return; // Exit if the value is not a valid number
      }
    }
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      items: formData.items,
      supplier_id: formData.supplier_id,
      manufacturer_id: formData.manufacturer_id,
      brands_id: formData.brands_id,
      qty: formData.qty,
      purchase_id: selectedPurchase.purchase_id,
      price_per_units: formData.price_per_units,
      status: formData.status,
    };

    console.log('payload', payload);
    try {
      await createPurchaseorder(payload);
      toast.success('Purchase Order added successfully');
      onClose();
      reloadlist();
    } catch (error) {
      console.error('Error saving Purchase Order data:', error);
      toast.error('Error saving Order');
    }
  };

  return (
    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{ fontFamily: "poppins" }}>Add Purchase Order</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
          </div>
          <div className="modal-body" style={{ fontFamily: "poppins" }}>
            <form onSubmit={handleSubmit}>

              <div className="container mt-4">
                <h2 className="mb-3">Purchase Orders</h2>
                {Array.isArray(PO_Data) && PO_Data.length > 0 ? (
                  <table className="table table-sm  table-bordered table-striped">
                    <thead className="thead-dark">
                      <tr>
                        <th>Date</th>
                        <th>Brands ID</th>
                        <th>Supplier ID</th>
                        <th>Product ID</th>
                        <th>Manufacturer ID</th>
                        <th>Quantity</th>
                        <th>Price (INR)</th>
                        <th>PO ID</th>
                      </tr>
                    </thead>
                    <tbody>
                      {PO_Data.map((item) => (
                        <tr key={item.id}>
                          <td>{item.date}</td>
                          <td>{item.brands_id}</td>
                          <td>{item.supplier_id}</td>
                          <td>{item.product_id}</td>
                          <td>{item.manufacturer_id}</td>
                          <td>{item.qty}</td>
                          <td>{item.price || "N/A"}</td>
                          <td>{item.po_id}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="alert alert-warning">No Purchase Orders available.</div>
                )}
              </div>
              <button type="submit" className="btn btn-primary float-end">
                {selectedPurchase ? 'Update Purchase' : 'Add Purchase'}
              </button>
              <button
                type="button"
                className="btn btn-secondary ml-2 float-end me-1"
                onClick={onClose}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export { SalesForm, SalesTable, PurchaseorderForm };
